import * as angular from "angular";
import * as _ from "lodash";
import {LocalStoreService} from "./local-store-service.service";
import {DataStoreConfig} from "./models/datastore-config.model";
import {ThreeplService} from "../threePL/models/threepl-service.model";

export class BringozStoreService {

  constructor(private localStoreService: LocalStoreService, private Deliveries_DS: DataStoreConfig, private Tasks_DS: DataStoreConfig,
              private Accounts_DS: DataStoreConfig, private Agents_DS: DataStoreConfig,
              private LeanPlanningRoutes_DS: DataStoreConfig, private Routes_DS: DataStoreConfig,
              private Location_DS: DataStoreConfig, private Itineraries_DS: DataStoreConfig,
              private Itineraries_Pageable_DS: DataStoreConfig, private Routes_Pageable_DS: DataStoreConfig,
              private Fulfillment_Pageable_DS: DataStoreConfig,
              private FulfillmentStep_DS: DataStoreConfig,
              private Three_PL_Services_DS: DataStoreConfig) {
  }

  save<T>(dataStore: DataStoreConfig, entities: T[]): void {
    if (_.isEqual(dataStore.objectStoreName, this.Deliveries_DS.objectStoreName)) {
      this.persistDeliveries(entities);
    }  else if (_.isEqual(dataStore.objectStoreName, this.Itineraries_DS.objectStoreName)) {
      this.persistItineraries(entities);
    } else if (_.isEqual(dataStore.objectStoreName, this.LeanPlanningRoutes_DS.objectStoreName)) {
      this.persistRoutes(entities);
    } else if (_.isEqual(dataStore.objectStoreName, this.Routes_DS.objectStoreName)) {
      this.persistRoutes(entities);
    } else if (_.isEqual(dataStore.objectStoreName, this.Itineraries_Pageable_DS.objectStoreName)) {
      this.persistPageableItineraries(entities);
    } else if (_.isEqual(dataStore.objectStoreName, this.Routes_Pageable_DS.objectStoreName)) {
      this.persistPageableRoutes(entities);
    } else if (_.isEqual(dataStore.objectStoreName, this.Agents_DS.objectStoreName)) {
      this.persistAgents(entities);
    } else if (_.isEqual(dataStore.objectStoreName, this.Fulfillment_Pageable_DS.objectStoreName)) {
      this.persistFulfillment(_.flatMap(entities, 'content'));
    } else {
      this.saveToLocalStore(dataStore, entities);
    }
  }

  private persistDeliveries(deliveries) {

    this.saveToLocalStore(this.Deliveries_DS, deliveries);

    _.forEach(deliveries, (delivery) => {
      if (delivery) {

        if (delivery.taskList) {
          this.saveToLocalStore(this.Tasks_DS, delivery.taskList);
        }
      }
    });
  }

  private persistItineraries(itineraries) {

    this.saveToLocalStore(this.Itineraries_DS, itineraries);

    const itineraryTasks = _.uniqBy(_.flatMap(itineraries, (itinerary) => {
      return _.concat(_.get(itinerary, 'taskList', []), _.get(itinerary, 'taskListExt', []))
    }), 'id');

    this.saveToLocalStore(this.Tasks_DS, itineraryTasks);
  }

  private persistRoutes(routes) {

    this.saveToLocalStore(this.LeanPlanningRoutes_DS, routes);
    this.saveToLocalStore(this.Routes_DS, routes);

    const routesTasks = _.compact(_.uniqBy(_.flatMap(routes, (r) => {
      return _.concat(r.taskList, r.taskListExt)
    }), 'id'));

    this.saveToLocalStore(this.Tasks_DS, routesTasks);
  }

  private persistPageableItineraries(itineraries) {
    this.persistItineraries(_.flatMap(itineraries, 'content'));
  }

  private persistPageableRoutes(routes) {
    this.persistRoutes(_.flatMap(routes, 'content'));
  }

  private persistAgents(agents) {
    this.saveToLocalStore(this.Agents_DS, agents);
  }

  private persistFulfillment(fulfillments) {
    this.saveToLocalStore(this.Fulfillment_Pageable_DS, fulfillments);
    const steps = _.flatMap(fulfillments, 'fulfillmentSteps');
    this.saveToLocalStore(this.FulfillmentStep_DS, steps);
  }

  private saveToLocalStore<T>(dataStore: DataStoreConfig, data): void {
    // FIXME
    const entities: T[] = _.isArray(data) ? data : [data];
    this.localStoreService.save(dataStore, entities);
  }
}

angular
  .module('bringoz.admin.persistence')
  .service('bringozStoreService', BringozStoreService);
